package common

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 17.10.22
 * Author : marcusspors
 */
enum class ECssClasses(val mClassName: String) {

    SLIDER_IMAGE_ROW("slider-image-row"),
    VERTICAL_GRID("vertical-grid"),
    NON_SCROLLABLE_GRID("non-scrollable-grid"),
    FULL_WIDTH_ROW("full-width-row"),
    FULL_WIDTH_COL("full-width-col"),
    TITLE_FONT("title-font"),
    BODY_FONT("body-font"),
    PRIMARY_BUTTON("primary-button"),
    SECONDARY_BUTTON("secondary-button"),
    TERTIARY_BUTTON("tertiary-button"),
    ACTION_BUTTON("action-button"),
    BODY("root-body"),
    TOOLBAR_BACKGROUND("toolbar-custom-background"),
    FADE_IN("fade-in"),
    COLOUR_CARD_ITEM("colour_card_item"),
    LIST_HEADER_FONT("list_header_font"),
    BUTTON_SPACER("button_spacer"),
    PRODUCT_CARD_ITEM("product_card_item"),
    PRODUCT_CARD_ITEM_SMALL_FONT("product_card_item_small_font"),
    PRODUCT_CARD_ITEM_MEDIUM_FONT("product_card_item_medium_font"),
    PRODUCT_CARD_ITEM_MEDIUM_FONT_WEIGHTED("product_card_item_medium_font_weighted"),
    PRODUCT_CARD_ITEM_AMOUNT_FONT("product_card_item_amount_font"),
    FLEXBOX_COL("flexbox_col"),
    SPEECHBUBBLE("speechbubble"),
    SPEECHBUBBLE_HIDER("speechbubble-hider"),
    BURGER_MENU_ITEM("burger_menu_item"),
    BURGER_MENU_TOP_ITEM("burger_menu_top_item"),
    BURGER_MENU_LEGAL_ITEM("burger_menu_legal_item"),
    BURGER_MENU_NOTE_TITLE("burger_menu_note_title"),
    BURGER_MENU_NOTE("burger_menu_note"),
    DIVIDER("divider"),
    CURSOR_HOVER("cursor"),
    LIST_NOTE_STYLE("list_note_style"),
    BOTTOM_BUTTONS("bottom_buttons"),
    ION_ALERT_BUTTON("sc-ion-alert-md"),
    ION_ALERT_BUTTON_ROLE_DESTRUCTIVE("alert-button-role-destructive"),
    ION_TOOLBAR_NO_BACKGROUND("ion-toolbar-no-background"),
    TOUR_BACKGROUND("tour_background"),
    TOUR_TOP_ELLIPSE("tour_top_ellipse"),
    TOUR_ELLIPSE_CIRCLE("tour_ellipse_circle"),
    TOUR_ELLIPSE_ICON("tour_ellipse_icon"),
    TOUR_PRIMARY_BUTTON("tour_primary_button"),
    TOUR_SECONDARY_BUTTON("tour_secondary_button"),
    VIEWPAGE_INDICATORS("viewpage-indicators"),
    INDICATOR("indicator"),
    NOTCH_INDICATOR("notch_indicator"),
    TOUR_STAGE_1_BACKGROUND("tour_stage_1_background"),
    TOUR_STAGE_1_HAND_WITH_PHONE("tour_stage_1_hand_with_phone"),
    TOUR_STAGE_1_HAND_WITH_PHONE_FLASH("tour_stage_1_hand_with_phone_flash"),
    TOUR_STAGE_1_HAND_WITH_PHONE_FLASH_BACKGROUND("tour_stage_1_hand_with_phone_flash_background"),
    TOUR_STAGE_1_CAM_INDICATOR("tour_stage_1_cam_indicator"),
    TOUR_STAGE_2_COLOUR_EXPANDABLE_ITEM_BACKGROUND("tour_stage_2_colour_expandable_item_background"),
    TOUR_STAGE_4_BACKGROUND("tour_stage_4_background"),
    TOUR_STAGE_4_BUY_OPTION("tour_stage_4_buy_option"),
    TOUR_STAGE_4_HEADLINE("tour_stage_4_headline"),
    TOUR_COLOUR_EXPANDABLE_ITEM("tour_colour_expandable_item"),
    ANIMATION_CONTAINER("animation_container"),
    ACTIVE("active"),
    TOUR_STAGE_2_COLOUR_FAN("tour_stage_2_colour_fan"),
    TOUR_STAGE_2_COLOUR_FAN2("tour_stage_2_colour_fan2"),
    TOUR_STAGE_2_COLOUR_FAN_BLUE1("tour_stage_2_colour_fan_blue1"),
    TOUR_STAGE_2_COLOUR_FAN_BLUE2("tour_stage_2_colour_fan_blue2"),
    TOUR_STAGE_2_COLOUR_FAN_BLUE3("tour_stage_2_colour_fan_blue3"),
    TOUR_STAGE_2_COLOUR_FAN_BLUE4("tour_stage_2_colour_fan_blue4"),
    TOUR_STAGE_2_MARKER1("tour_stage_2_marker1"),
    TOUR_STAGE_2_MARKER2("tour_stage_2_marker2"),
    TOUR_STAGE_2_MARKER3("tour_stage_2_marker3"),
    TOUR_STAGE_2_MARKER4("tour_stage_2_marker4"),
    TOUR_STAGE_2_UPPER_IMAGE("tour_stage_2_upper_image"),
    LOADING_SPINNER_CONTAINER("loading_spinner_container"),
    LOADING_SPINNER_ROLLER("loading_spinner_roller"),
    LOADING_SPINNER_COLOR_FIELD("loading_spinner_color_field"),
    LOADING_SPINNER_COLOR_FIELD_CONTAINER("loading_spinner_color_field_container")
    ;

    val mClassSelector: String = ".${this.mClassName}"

}